import { FlexColumnDiv } from '@/components/shared/components/common.StyledComponents';
import { NoMarginParagraph } from '@/components/shared/components/LabelValuePair/LabelValuePair.StyledComponents';
import { CarrierInfoProps, LoadTypes } from '../Applicant.types';
import { ApplicantInfoCard, ApplicantInfoRow } from './ApplicantInfoCard';

export const CarrierInformation = ({
    mcNumber,
    usDOT,
    stateDOT,
    stateDOTIssuer,
    companyOwnedTrucks,
    haulsLoadsAcrossUsBorders,
    ownerOperators,
    loadTypes,
}: CarrierInfoProps) => {
    return (
        <ApplicantInfoCard title="Carrier Information">
            <ApplicantInfoRow label="MC Number" value={mcNumber} data-testid="mcNumber" />
            <ApplicantInfoRow label="USDOT Number" value={usDOT} data-testid="usDOT" />
            <ApplicantInfoRow label="State DOT Number" value={stateDOT} data-testid="stateDOT" />
            <ApplicantInfoRow
                label="DOT Issuing State"
                value={stateDOTIssuer}
                data-testid="stateDOTIssuer"
            />
            <ApplicantInfoRow
                label="# Company Owned Trucks"
                value={companyOwnedTrucks}
                data-testid="companyOwnedTrucks"
            />
            <ApplicantInfoRow
                label="Do you haul across state lines?"
                value={
                    haulsLoadsAcrossUsBorders === null
                        ? null
                        : haulsLoadsAcrossUsBorders
                          ? 'Yes'
                          : 'No'
                }
                data-testid="hauls-loads-across-us-borders"
            />
            <ApplicantInfoRow
                label="# Owner Operators"
                value={ownerOperators}
                data-testid="ownerOperators"
            />
            <ApplicantInfoRow
                label="Types of Loads to be Factored"
                value={
                    loadTypes?.length > 0 && (
                        <FlexColumnDiv>
                            {loadTypes.map((loadType) => (
                                <NoMarginParagraph key={loadType}>
                                    {LoadTypes[loadType]}
                                </NoMarginParagraph>
                            ))}
                        </FlexColumnDiv>
                    )
                }
                data-testid="loadTypes"
            />
        </ApplicantInfoCard>
    );
};
